import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiConstants } from 'app/constants/api-constants';
import { Contract } from 'app/models/dataPrediction/contract.model';
import { ApiService } from 'app/shared/services/api.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PredictionsService {
  private _apiUserUrl = ApiConstants.DATA_PREDICTION_ENDPOINT;

  constructor(private apiService: ApiService) { }
    getContracts(): Observable<any> {
      return this.apiService.get<any>(`${this._apiUserUrl}/contracts`);
    }

    getProductionRuns(contractId: number) {
      return this.apiService.get<any>(`${this._apiUserUrl}/productionRuns/${contractId}`);
    }

    getPriceCorridors(seriesId: number, productionRun: number) {
      return this.apiService.get<any>(`${this._apiUserUrl}/priceCorridors/${seriesId}/${productionRun}`);
    }

    getTimeSeries(seriesId: number, startDate: Date, endDate: Date) {
      return this.apiService.get<any>(`${this._apiUserUrl}/timeSeries/${seriesId}?startDate=${startDate.toISOString()}&endDate=${endDate.toISOString()}`);
    }

}
